import { env } from "configs/EnvironmentConfig";
import fetch from "../auth/FetchInterceptor";

const CustomerService = {};

// khách hàng
CustomerService.listCustomer = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort
) {
  return fetch({
    url: `${env.API_MSP}/customers`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[record_status]": "O",
    },
  });
};

// Detail khách hàng
CustomerService.detailCustomer = function (id) {
  return fetch({
    url: `${env.API_MSP}/customers/${id}`,
    method: "get",
  });
};

// Create khách hàng
CustomerService.createCustomer = function (data) {
  return fetch({
    url: `${env.API_MSP}/customers`,
    method: "post",
    data,
  });
};

// Create tài khoản ngân hàng
CustomerService.createAccountBank = function (data, bu_code) {
  return fetch({
    url: `${env.API_MSP}/accounts`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit khách hàng
CustomerService.editCustomer = function (data, id) {
  return fetch({
    url: `${env.API_MSP}/customers/${id}`,
    method: "put",
    data,
  });
};

// Delete khách hàng
CustomerService.deleteCustomer = function (id) {
  return fetch({
    url: `${env.API_MSP}/customers/${id}`,
    method: "delete",
  });
};

// listAllCustomer
CustomerService.listAllCustomer = function (type_id) {
  return fetch({
    url: `${env.API_MSP}/customers`,
    method: "get",
    params: {
      page: -1,
      sort: "code",
      "filter[record_status]": "O",
      //   "filter[type_id]": type_id,
    },
  });
};

// listAllAccountBank
CustomerService.listAllAccountBank = function (bu_code) {
  return fetch({
    url: `${env.API_MSP}/accounts`,
    method: "get",
    params: {
      page: -1,
      sort: "code",
      "filter[record_status]": "O",
      //   "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      //   "filter[type_id]": type_id,
    },
  });
};

export default CustomerService;
